import FormulaInterface from "./FormulaInterface.ts";
import ArgumentInterface from "./ArgumentInterface.ts";

export default class Formula implements FormulaInterface {
    name: string;
    args: Array<ArgumentInterface>;
    returnType: string;

    /**
     * @param name
     * @param returnType
     */
    constructor(name: string, returnType: string) {
        this.name = name;
        this.args = [];
        this.returnType = returnType;
    }

    getName(): string {
        return this.name.toUpperCase();
    }

    getReturnType(): string {
        return this.returnType;
    }

    setReturnType(returnType: string): FormulaInterface {
        this.returnType = returnType;

        return this;
    }

    /**
     * @param argument
     */
    addArgs(argument: ArgumentInterface): FormulaInterface {
        this.args.push(argument);

        return this;
    }

    getArgs(): Array<ArgumentInterface> {
        return this.args;
    }


}


// WEBPACK FOOTER //
// ./src/Models/pricingRulesInterface/Formula.ts